import React, {useState,useEffect} from 'react'
import styled from "styled-components"
import Episode from './Episode'
import {useDispatch} from "react-redux"
import {setPlaylistEpisodes} from "../../actions/set-Playlist-Episodes"
import {useHistory, useLocation, useParams} from "react-router-dom";
import DB from "../../other/local-db"
import {generateUrl} from "../../other/generate-url"
import {getImageUrl} from "../../other/axios"

const Select = styled.select`
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 1.1rem;
    background-color: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    color: white;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    outline: 0;
    font-weight: 600;
    padding: 12px 15px;
    transition: all 0.3s ease;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 1em;

    &:focus, &:hover {
        border-color: #00d2ff;
        box-shadow: 0 0 15px rgba(0, 210, 255, 0.3);
        background-color: rgba(255, 255, 255, 0.1);
    }
`

const Container = styled.div`
    margin-top: 1.5rem;
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
`

const Seasons = ({seasonData, cover}) => {
    const [seasons,setSeasons] = useState([])
    const [streamStat, setStreamStat] = useState({})
    const [selectedSeason, setSelectedSeason] = useState();

    const {stream_id} = useParams();
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    
    useEffect(()=>{
        if(!seasonData) return;
        console.log("Seasons: Received seasonData", seasonData);
        
        let s = [];
        try {
            // Se for array (ex: [ {episode_num: 1, season: 1, ...} ])
            if (Array.isArray(seasonData)) {
                const seasonsMap = {};
                seasonData.forEach(ep => {
                    const sNum = ep.season || 1;
                    if (!seasonsMap[sNum]) seasonsMap[sNum] = [];
                    seasonsMap[sNum].push(ep);
                });
                s = Object.keys(seasonsMap).map(x => ({
                    id: parseInt(x),
                    name: "Temporada " + x,
                    episodes: seasonsMap[x].map(y => ({
                        ...y,
                        episode_num: parseInt(y.episode_num),
                        url: generateUrl("series", y.id, y.container_extension),
                        url2: generateUrl("series", y.id, y.container_extension)
                    }))
                }));
            } else {
                // Se for objeto (ex: { "1": [ {episode_num: 1, ...} ] })
                s = Object.keys(seasonData).map(x => ({
                    id: parseInt(x),
                    name: "Temporada " + x,
                    episodes: seasonData[x].map(y => ({
                        ...y,
                        episode_num: parseInt(y.episode_num),
                        url: generateUrl("series", y.id, y.container_extension),
                        url2: generateUrl("series", y.id, y.container_extension)
                    }))
                }));
            }
        } catch (e) {
            console.error("Seasons: Error parsing seasonData", e);
        }

        if(s.length > 0){
            setSeasons(s);
            let stat = DB.findOne("series",stream_id) || {id: stream_id, season: s[0].id, episode: s[0].episodes[0].episode_num, start:0};
            setSelectedSeason(parseInt(stat.season) || s[0].id);
            setStreamStat(stat);
        }
    }, [seasonData, stream_id])

    const playEpisode = (episode) =>{
        const currentSeason = seasons.find(x=>x.id === selectedSeason);
        if(!currentSeason) return;
        const list = currentSeason.episodes.map(x=> {return{...x, id:x.id}});
        dispatch(setPlaylistEpisodes(list))
        history.push(location.pathname.replace("info",`play/season/${selectedSeason}/episode/${episode}`))
    }

    return (
        <>
        <div className="row align-items-center" style={{marginTop: '20px'}}>
            <div className="col-md-7">
                <h3 style={{color: '#fff', textTransform: 'uppercase', fontSize: '1.2rem'}}>Episódios</h3>
            </div>
            <div className="col-md-5">
                <Select onChange={e=> setSelectedSeason(parseInt(e.target.value))} value={selectedSeason}>
                    {seasons.map(x=> <option value={x.id} key={"season-"+x.id}>{x.name} ({x.episodes.length} eps)</option>)}
                </Select>
            </div>
        </div>
        <Container>
            {seasons.find(x=> x.id === selectedSeason) && (
                seasons.find(x=> x.id === selectedSeason).episodes.map(ep=>
                    <Episode  key={"ep-"+ep.id}
                    episode={ep.episode_num} 
                    image={getImageUrl(ep.info.movie_image || cover)}
                    cover={getImageUrl(cover)}
                    duration={ep.info.duration_secs}
                    title={ep.title}
                    description={ep.overview}
                    selected={streamStat && ep.episode_num===streamStat.episode && selectedSeason === streamStat.season}
                    percentage={streamStat && ep.episode_num===streamStat.episode && selectedSeason === streamStat.season ? streamStat.tot : false}
                    playEpisode={playEpisode}
                    url={ep.url2}
                    />    
                )
            )}
        </Container>
        </>
    )
}

export default Seasons
